export default __webpack_public_path__ + "static/media/cardestudantil.c1260124.png";